import { createSvgIcon } from "@mui/material";

export const AlignRightIcon = createSvgIcon(
  <svg viewBox="0 0 15 9" fill="none">
    <path
      fill="currentColor"
      d="M13.903 0c.37 0 .633.29.633.633v7.172a.61.61 0 0 1-.633.633.625.625 0 0 1-.633-.633V4.852H.635a.634.634 0 0 1-.001-1.266H13.27V.633c0-.343.29-.633.632-.633"
    />
  </svg>,
  "AlignRightIcon",
);
